import React, {FC} from 'react';
import styled from 'styled-components';

import {TooltipCoordinator} from '../../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {emojiToDefinition} from '../../../../../../srcCommon/helpers/emoji/emojiTextHelpers';
import {TagHighlightEmojiModel} from '../../../../../models/api/tagModel';
import {baseEmojiValidationMap} from '../../../../../services/emojis/emojis';
import {Emoji} from '../../../../common/emoji/emoji';

/*
 * Props.
 */

interface CellTagEmojiProps {
  tag: TagHighlightEmojiModel;
}

/*
 * Style.
 */

const StyledEmojiTagDiv = styled(TooltipCoordinator)``;

const StyledEmojiTooltipDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

/*
 * Component.
 */

export const CellTagEmoji: FC<CellTagEmojiProps> = (props) => {
  const definition = emojiToDefinition(props.tag.highlightEmoji, baseEmojiValidationMap);
  if (!definition) {
    return null;
  }

  return (
    <StyledEmojiTagDiv
      render={() => (
        <StyledEmojiTooltipDiv>
          <Emoji {...definition} size={12} />
          {props.tag.name}
        </StyledEmojiTooltipDiv>
      )}
    >
      <Emoji {...definition} size={16} />
    </StyledEmojiTagDiv>
  );
};
